module.exports = "./img/4d1e0c5a7bce4f755b500de0d2cbc9ff.jpg";